import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.894 3.383a3.03 3.03 0 0 1 2.142-.873h8.822L20 6.584V19.53c0 .822-.338 1.572-.888 2.107a3.06 3.06 0 0 1-2.143.874H7.031a3.03 3.03 0 0 1-2.143-.874A2.96 2.96 0 0 1 4 19.53V5.186c.132-.969.476-1.397.894-1.803"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11 17.966 1.327-.898 2.617 1.942 2-1.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M14 11.51H7M16 7.51H7"
    }, null, -1)
  ])))
}
export default { render: render }